export const getLineNumber = (row, index) =>
  Number.isFinite(row?.lineNumber) ? row.lineNumber : index + 1;

export const isRowSelectable = (row) =>
  !(Array.isArray(row?.errors) && row.errors.length > 0);

export const isBankCredit = (type) => {
  if (typeof type !== "string") {
    return false;
  }
  const normalized = type.trim().toLowerCase();
  return normalized.length > 0 && normalized.includes("bankgutschrift");
};

export const formatDateTime = (value) => {
  if (!value) {
    return "";
  }
  try {
    return new Date(value).toLocaleString("de-DE");
  } catch (error) {
    return value;
  }
};

export const formatAmount = (amount, currency) => {
  if (amount == null) {
    return "";
  }
  const numeric = Number(amount);
  const code = currency || "EUR";
  if (!Number.isFinite(numeric)) {
    return String(amount);
  }
  try {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: code,
    }).format(numeric);
  } catch (error) {
    return String(amount);
  }
};
